import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, NavigationStart, Router } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { environment } from '../environments/environment';
import { jwtDecode } from 'jwt-decode';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { logindetails } from './services/logindetail';
import { RoleViewService } from './services/role-view.service';

@Component({
  selector: 'app-root',
  standalone:true,
  imports:[CommonModule, RouterModule, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'CERT';
  userLogin = false;
  codeResponse: any;
  idToken: any;
  accessToken: any;
  refresToken: any;
  isActive = false;
  initialLoaderName = 'initialLoading'
  applicationStatus: 'Loading' | 'Error' | 'Render' = 'Loading';
  showApp = false;
  errorPageConfig: any = {
    status: 404,
    title: 'PAGE NOT FOUND',
    description: 'We are sorry, but the page you requested was not found.'
  }
  private readonly UNAUTHORIZED_ROUTE = '/unauthorized';
  private readonly ERROR_STATUS = 'Error';
  private readonly AUTHENTICATION_ERROR_TITLE = 'Authentication Error';
  private readonly UNAUTHORIZED_ACCESS_TITLE = 'Unauthorized Access';
  private readonly PROJECT_RETURN_URL_KEY = 'projectReturnUrl';
  // Guards against the NavigationStart subscriber (below) and processAuthCallback()
  // (called from ngOnInit) both racing to exchange the same auth code and both
  // finalizing the login (history.replaceState + loggedIn()). Only the first one
  // to reach this point wins; the loser bails out so it can't stomp on the
  // deep-link URL (e.g. stripping ?fromManageApproval=true) that the winner
  // already restored.
  private authExchangeClaimed = false;

  private readonly HEADERS = {
      CONTENT_TYPE_FORM: 'application/x-www-form-urlencoded; charset=UTF-8',
      ACCEPT_JSON: 'application/json'
    };
  currentUserAccessTkn: any;
  currentUserIDTkn: any
  https =inject(HttpClient);
  constructor(readonly router: Router, readonly cdr: ChangeDetectorRef, private readonly roleViewService: RoleViewService
  ) {
    this.checkAuthenticationBeforeInit();

 router.events.subscribe(async (event: any) => {//NOSONAR
      if (event instanceof NavigationStart) {
        const authCodeProcessed = sessionStorage.getItem('authCodeProcessed');
        if (globalThis.location.href.includes('code') && !authCodeProcessed) {
          if (!this.claimAuthCodeHandling()) {
            return;
          }
          sessionStorage.setItem('authCodeProcessed', 'true');
          const url = globalThis.location.href.split('?')[1]
          if (url.includes('error')) {
            this.isActive = false;
            this.errorPageConfig = {
              status: 401,
              title: this.UNAUTHORIZED_ACCESS_TITLE,
              description: "We are sorry, you can't access the page requested"
            }
            this.applicationStatus = 'Error';

            globalThis.location.hash = `#${this.UNAUTHORIZED_ROUTE}`;
            this.router.navigateByUrl(this.UNAUTHORIZED_ROUTE);
          }
          else {
            this.codeResponse = globalThis.location.href.split('?')[1].split('code=')[1].split('&')[0];
            sessionStorage.setItem('codeResponse', this.codeResponse);
            
            // Ensure PKCE values are initialized before exchanging code
            await logindetails.ensureInitialized();
            
            const codeVerifier = logindetails.codeVerifier;
            
            if (!codeVerifier) {
              throw new Error('Code verifier is missing');
            }

            const details: any = {
              'grant_type': environment.grantType,
              'client_id': environment.clientId,
              'code': this.codeResponse,
              'redirect_uri': environment.redirectURI,
              'code_verifier': codeVerifier,
            };
            const formBody = [];
            for (const property in details) {
              const encodedKey = encodeURIComponent(property);
              const encodedValue = encodeURIComponent(details[property]);
              formBody.push(`${encodedKey}=${encodedValue}`);
            }
            const body = formBody.join("&");
            
            // Build headers for Azure AD token request - must include all required headers for SPA CORS
            const isIEOrEdge = /msie\s|trident\/|edge\//i.test(globalThis.navigator.userAgent);
            const headerObj: any = {
              'Content-Type': this.HEADERS.CONTENT_TYPE_FORM,
              'Accept': this.HEADERS.ACCEPT_JSON
            };
            
            // Add IE/Edge specific cache headers
            if (isIEOrEdge) {
              headerObj['Cache-Control'] = 'no-cache';
              headerObj['Pragma'] = 'no-cache';
            }
            
            const headers = new HttpHeaders(headerObj);
            
            try {
              const res:any = await lastValueFrom(this.https.post(environment.tokenURL, body, { headers }));
              
              if (res !== null && res !== undefined && res !== '' && !res.hasOwnProperty('error')) {
                this.idToken = res.id_token;
                this.accessToken = res.access_token;
                this.refresToken = res.refresh_token;
                sessionStorage.setItem('token', this.accessToken);
                sessionStorage.setItem('Refresh_token', this.refresToken);
                sessionStorage.setItem('id_token', this.idToken);
                sessionStorage.setItem('lastModifiedOn', Date.now().toString());
                setInterval(() => {
                  this.refreshToken();
                }, 900000);
                if (this.idToken !== null || this.accessToken !== null) {
                  const decodedIDToken: any = jwtDecode(this.idToken);
                  const decodedACCESSToken: any = jwtDecode(this.accessToken);
                  sessionStorage.setItem('CERT_IDTOKEN', JSON.stringify(decodedIDToken));
                  sessionStorage.setItem('CERT_ACCESSTOKEN', JSON.stringify(decodedACCESSToken));
                  this.currentUserAccessTkn = JSON.parse(sessionStorage.getItem('CERT_ACCESSTOKEN') ?? "");
                  this.currentUserIDTkn = JSON.parse(sessionStorage.getItem('CERT_IDTOKEN') ?? "");

                  const currentUserName = this.currentUserAccessTkn['name'];
                  const UserInfo: any = {
                    'userName': currentUserName
                  }
                  sessionStorage.setItem('UserInfo', JSON.stringify(UserInfo));
                  
                  this.roleViewService.reinitialize();
                  
                  // Clear flags and URL parameters
                  sessionStorage.removeItem('redirecting');
                  sessionStorage.removeItem('authCodeProcessed');
                  
                  // Clear URL parameters and navigate to dashboard
                  globalThis.history.replaceState({}, document.title, globalThis.location.pathname + globalThis.location.hash.split('?')[0]);
                  this.loggedIn();

                  // Update RoleViewService so header and other components receive the username
                  this.roleViewService.setUserName(currentUserName);
                }
              } else {
                // Handle Azure AD error response
                const userMessage = 'Please try again or contact support';
                
                this.errorPageConfig = {
                  status: 401,
                  title: this.AUTHENTICATION_ERROR_TITLE,
                  description: userMessage
                };
                this.applicationStatus = 'Error';
                globalThis.location.hash = `#${this.UNAUTHORIZED_ROUTE}`;
                this.router.navigateByUrl(this.UNAUTHORIZED_ROUTE);
              }
            } catch (error: any) {
              
              let errorMessage = 'An error occurred during authentication. Please try again.';
              if (error?.error?.error) {
                const errCode = error.error.error;
                const errDesc = error.error.error_description || '';
                const aadMatch = errDesc.match(/(AADSTS\d+):/);
                const finalCode = aadMatch ? aadMatch[1] : errCode;
                errorMessage = 'Error';
              }
              
              this.errorPageConfig = {
                status: 500,
                title: this.AUTHENTICATION_ERROR_TITLE,
                description: errorMessage
              };
              this.applicationStatus = 'Error';
              globalThis.location.hash = `#${this.UNAUTHORIZED_ROUTE}`;
              this.router.navigateByUrl(this.UNAUTHORIZED_ROUTE);
            }
          }

        }
      }
    })
  }
  ngOnInit() {
    sessionStorage.removeItem('redirecting');
    sessionStorage.removeItem('loggingOut');
    sessionStorage.removeItem('roleRedirecting');
    
    if (sessionStorage.getItem('appInitialized')) {
      return;
    }
    
    if (sessionStorage.getItem('UserInfo')) {
      sessionStorage.setItem('appInitialized', 'true');
      this.loggedIn();
    } else if (globalThis.location.href.includes('code=')) {
      this.processAuthCallback();
    } else if (globalThis.location.href.includes('error=')) {
      this.handleAuthError();
    } else {
      this.redirectToLogin();
    }
  }

  private async processAuthCallback() {
    if (!this.claimAuthCodeHandling()) {
      return;
    }
    const currentCode = globalThis.location.href.split('?')[1].split('code=')[1].split('&')[0];
    const processedCode = sessionStorage.getItem('processedCode');
    
    if (processedCode === currentCode) {
      if (sessionStorage.getItem('UserInfo')) {
        this.loggedIn();
      } else {
        sessionStorage.removeItem('processedCode');
        sessionStorage.removeItem('code_verifier');
        this.redirectToLogin();
      }
      return;
    }

    this.codeResponse = currentCode;
    sessionStorage.setItem('codeResponse', this.codeResponse);
    sessionStorage.setItem('processedCode', currentCode);
    
    try {
      await logindetails.ensureInitialized();
      
      const codeVerifier = logindetails.codeVerifier;
      if (!codeVerifier) {
        throw new Error('Code verifier is missing');
      }
      
      const details: any = {
        'grant_type': environment.grantType,
        'client_id': environment.clientId,
        'code': this.codeResponse,
        'redirect_uri': environment.redirectURI,
        'code_verifier': codeVerifier,
      };
      
      const formBody = [];
      for (const property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        formBody.push(`${encodedKey}=${encodedValue}`);
      }
      const body = formBody.join("&");
      
      const isIEOrEdge = /msie\s|trident\/|edge\//i.test(globalThis.navigator.userAgent);
      const headerObj: any = {
         'Content-Type': this.HEADERS.CONTENT_TYPE_FORM,
          'Accept': this.HEADERS.ACCEPT_JSON
      };
      
      if (isIEOrEdge) {
        headerObj['Cache-Control'] = 'no-cache';
        headerObj['Pragma'] = 'no-cache';
      }
      
      const headers = new HttpHeaders(headerObj);
      const res: any = await lastValueFrom(this.https.post(environment.tokenURL, body, { headers }));
      if (res && !res.error) {
        this.idToken = res.id_token;
        this.accessToken = res.access_token;
        this.refresToken = res.refresh_token;
        sessionStorage.setItem('token', this.accessToken);
        sessionStorage.setItem('Refresh_token', this.refresToken);
        sessionStorage.setItem('id_token', this.idToken);
        sessionStorage.setItem('lastModifiedOn', Date.now().toString());
        
        setInterval(() => {
          this.refreshToken();
        }, 900000);
        
        if (this.idToken && this.accessToken) {
          const decodedIDToken: any = jwtDecode(this.idToken);
          const decodedACCESSToken: any = jwtDecode(this.accessToken);
          sessionStorage.setItem('CERT_IDTOKEN', JSON.stringify(decodedIDToken));
          sessionStorage.setItem('CERT_ACCESSTOKEN', JSON.stringify(decodedACCESSToken));
          this.roleViewService.reinitialize();
          this.currentUserAccessTkn = JSON.parse(sessionStorage.getItem('CERT_ACCESSTOKEN') ?? "");
          this.currentUserIDTkn = JSON.parse(sessionStorage.getItem('CERT_IDTOKEN') ?? "");
          const UserInfo: any = {
            'userName': this.currentUserAccessTkn['name']
          }
          sessionStorage.setItem('UserInfo', JSON.stringify(UserInfo));
          sessionStorage.removeItem('redirecting');
          sessionStorage.removeItem('processedCode');
          globalThis.history.replaceState({}, document.title, globalThis.location.pathname + globalThis.location.hash.split('?')[0]);
          this.loggedIn();
        }
      } else {
        throw new Error(res?.error_description || 'Token exchange failed');
      }
    } catch (error: any) {
      console.info('[AppComponent] Authentication failed:', error);
      this.errorPageConfig = {
        status: 401,
        title: this.AUTHENTICATION_ERROR_TITLE,
        description: 'Failed to authenticate. Please try again.'
      };

      this.applicationStatus = this.ERROR_STATUS;
      this.router.navigateByUrl(this.UNAUTHORIZED_ROUTE);
    }
  }
  
  private handleAuthError() {
    this.isActive = false;
    this.errorPageConfig = {
      status: 401,
      title: this.UNAUTHORIZED_ACCESS_TITLE,
      description: "We are sorry, you can't access the page requested"
    }
    this.applicationStatus = 'Error';
    globalThis.location.hash = `#${this.UNAUTHORIZED_ROUTE}`;
    this.router.navigateByUrl(this.UNAUTHORIZED_ROUTE);
  }

  async refreshToken() {
  const refreshToken = sessionStorage.getItem('Refresh_token');
  const accessToken = sessionStorage.getItem('token');
  const idToken = sessionStorage.getItem('id_token');

  const isValidToken =
    refreshToken !== 'undefined' && refreshToken !== '' &&
    accessToken !== 'undefined' && accessToken !== '' &&
    idToken !== 'undefined' && idToken !== '';

  if (!isValidToken) {
    this.clearData();
    return;
  }

  const data: any = {
    grant_type: "refresh_token",
    client_id: environment.clientId,
    refresh_token: refreshToken
  };

  const refreshBody: string[] = [];
  for (const property in data) {
    refreshBody.push(
      `${encodeURIComponent(property)}=${encodeURIComponent(data[property])}`
    );
  }

  const body = refreshBody.join("&");

  const isIEOrEdge = /msie\s|trident\/|edge\//i.test(globalThis.navigator.userAgent);

  const headerObj: any = {
    'Content-Type': this.HEADERS.CONTENT_TYPE_FORM,
    'Accept': this.HEADERS.ACCEPT_JSON,
    'Origin': globalThis.location.origin
  };

  if (isIEOrEdge) {
    headerObj['Cache-Control'] = 'no-cache';
    headerObj['Pragma'] = 'no-cache';
  }

  const headers = new HttpHeaders(headerObj);

  try {
    const res: any = await lastValueFrom(
      this.https.post(environment.tokenURL, body, { headers })
    );

    const isSuccess =
      res !== null &&
      res !== undefined &&
      res !== '' &&
      !res.hasOwnProperty('error');

    if (isSuccess) {
      console.info('[AppComponent] Token refreshed successfully');

      this.idToken = res.id_token;
      this.accessToken = res.access_token;
      this.refresToken = res.refresh_token;

      sessionStorage.setItem('token', this.accessToken);
      sessionStorage.setItem('Refresh_token', this.refresToken);
      sessionStorage.setItem('id_token', this.idToken);

      sessionStorage.setItem('lastModifiedOn', Date.now().toString());
      return;
    }

    console.trace('[AppComponent] Token refresh failed:', res?.error, res?.error_description);

    const errorCode = res?.error || '';

    if (errorCode.includes('AADSTS70008') || errorCode.includes('invalid_grant')) {
      console.info('[AppComponent] Refresh token expired, clearing session');
      this.clearData();
    }

  } catch (error: any) {
    console.trace('[AppComponent] HTTP error during token refresh:', error);
    this.clearData();
  }
}

  clearData() {
    const confirmed = globalThis.confirm('Token Expired');
    if (confirmed) {
      sessionStorage.clear();
      globalThis.location.reload();
    }
  }

  loggedIn() {
    this.applicationStatus = 'Render';
    this.showApp = true;
    
    if (sessionStorage.getItem('navigationInProgress')) {
      return;
    }
    
    sessionStorage.setItem('navigationInProgress', 'true');
    sessionStorage.setItem('appInitialized', 'true');
    
    const roles = this.getUserRoles();
    
    if (!roles || roles.length === 0) {
      sessionStorage.removeItem('navigationInProgress');
      this.clearData();
      return;
    }

    const projectUrl = this.getRequestedProjectUrl();
    if (projectUrl) {
      sessionStorage.removeItem(this.PROJECT_RETURN_URL_KEY);
      this.router.navigateByUrl(projectUrl).then(() => {
        sessionStorage.removeItem('navigationInProgress');
      });
      return;
    }
    
    const hasAdminRole = roles.some(role => 
      role.toLowerCase() === 'cert.superadmin' || role.toLowerCase() === 'cert.admin'
    );
    const hasUserRole = roles.some(role => role.toLowerCase() === 'cert.user');
    
    if (hasAdminRole) {
      this.router.navigate(['/dashboard']).then(() => {
        sessionStorage.removeItem('navigationInProgress');
      });
    } else if (hasUserRole) {
      this.router.navigate(['/user-dashboard']).then(() => {
        sessionStorage.removeItem('navigationInProgress');
      });
    } else {
      sessionStorage.removeItem('navigationInProgress');
      this.clearData();
    }
  }
  
  private getUserRoles(): string[] {
    try {
      const idToken = sessionStorage.getItem('CERT_IDTOKEN');
      if (!idToken) {
        return [];
      }
      const decodedToken = JSON.parse(idToken);
      return decodedToken.roles || [];
    } catch (error) {
      console.trace('Failed to decode roles from token:', error);
      return [];
    }
  }

  async redirectToLogin() {
    if (sessionStorage.getItem('UserInfo')) {
      this.loggedIn();
      return;
    }

    const projectUrl = this.getRequestedProjectUrl();
    if (projectUrl) {
      sessionStorage.setItem(this.PROJECT_RETURN_URL_KEY, projectUrl);
    }
    
    if (sessionStorage.getItem('redirecting')) {
      return;
    }
    
    sessionStorage.setItem('redirecting', 'true');
    
    try {
      await logindetails.ensureInitialized();
      
      const codeChallenge = logindetails.codeChallenge;
      
      if (!codeChallenge) {
        sessionStorage.removeItem('redirecting');
        setTimeout(() => this.redirectToLogin(), 100);
        return;
      }
      
      const loginUrl = `${environment.baseLoginUrl}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
      globalThis.location.href = loginUrl;
    } catch (error) {
       console.trace('Redirect failed:', error);
      sessionStorage.removeItem('redirecting');
    }
  }

  private claimAuthCodeHandling(): boolean {
    if (this.authExchangeClaimed) {
      return false;
    }
    this.authExchangeClaimed = true;
    return true;
  }

  private getRequestedProjectUrl(): string | null {
    const storedUrl = sessionStorage.getItem(this.PROJECT_RETURN_URL_KEY);
    const hashUrl = globalThis.location.hash.replace(/^#/, '');
    const requestedUrl = storedUrl || hashUrl;
    return /^\/user-dashboard\/project\/[^/?#]+(?:\?.*)?$/.test(requestedUrl)
      ? requestedUrl
      : null;
  }

  private checkAuthenticationBeforeInit(): void {
    const isAuthCallback = globalThis.location.href.includes('code=') || globalThis.location.href.includes('error=');
    if (isAuthCallback) {
      // Keep showApp=false until token exchange completes in ngOnInit.
      // Setting it true here can render routes before tokens are stored.
      return;
    }
    
    const userInfo = sessionStorage.getItem('UserInfo');
    const idToken = sessionStorage.getItem('id_token');
    
    if (!userInfo || !idToken) {
      this.showApp = false;
      this.redirectToLogin();
      return;
    }
    
    try {
      const payload = JSON.parse(atob(idToken.split('.')[1]));
      const exp = payload.exp * 1000;
      if (Date.now() >= exp) {
        this.showApp = false;
        this.clearSessionAndRedirect();
        return;
      }
    } catch (error) {
      console.trace('Unexpected error occurred:', error);
      this.showApp = false;
      this.clearSessionAndRedirect();
      return;
    }
    
    this.showApp = true;
  }

  private clearSessionAndRedirect(): void {
    const keysToKeep = new Set(['code_verifier', 'code_challenge']);
    const keysToRemove: string[] = [];
    
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && !keysToKeep.has(key)) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
    this.redirectToLogin();
  }
}